export enum QuestionTypes {
    Text = "text",
    Checkbox = "checkbox",
    Radio = "radio",
}